(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["membership-order"] && !Shopify.designMode) return;
  try {
    
class MembershipOrder extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-plan-card]').forEach(card => {
      card.addEventListener('click', () => this.selectPlan(card));
    });
    this.querySelectorAll('[data-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => this.selectThumb(thumb));
    });
  }

  selectPlan(card) {
    const variantInput = this.querySelector('[data-variant-input]');
    const sellingPlanInput = this.querySelector('[data-selling-plan-input]');

    if (variantInput && card.dataset.variantId) variantInput.value = card.dataset.variantId;

    if (sellingPlanInput) {
      if (card.dataset.sellingPlanId) {
        sellingPlanInput.value = card.dataset.sellingPlanId;
        sellingPlanInput.disabled = false;
      } else {
        sellingPlanInput.disabled = true;
      }
    }

    const priceEl = this.querySelector('[data-plan-price]');
    if (priceEl && card.dataset.mainPrice) priceEl.textContent = card.dataset.mainPrice;

    const suffixEl = this.querySelector('[data-price-suffix]');
    if (suffixEl) suffixEl.textContent = card.dataset.priceSuffix || '';

    const titleEl = this.querySelector('[data-plan-title]');
    if (titleEl) titleEl.textContent = card.dataset.planTitle || card.dataset.label || titleEl.textContent;

    const taglineEl = this.querySelector('[data-tagline]');
    if (taglineEl) {
      const tagline = card.dataset.tagline || '';
      taglineEl.textContent = tagline;
      taglineEl.hidden = !tagline;
    }

    const badgeWrapper = this.querySelector('[data-badge-wrapper]');
    const badgeTextEl = this.querySelector('[data-badge-text]');
    if (badgeWrapper && badgeTextEl) {
      const badgeText = card.dataset.badgeText || '';
      badgeTextEl.textContent = badgeText;
      badgeWrapper.hidden = !badgeText;
    }

    const savingsWrapper = this.querySelector('[data-savings-wrapper]');
    const savingsEl = this.querySelector('[data-savings-badge]');
    if (savingsEl) {
      const text = card.dataset.savingsBadge || '';
      savingsEl.textContent = text;
      if (savingsWrapper) savingsWrapper.hidden = !text;
    }

    const ctaEl = this.querySelector('[data-cta-text]');
    if (ctaEl) ctaEl.textContent = card.dataset.ctaText || card.dataset.label || ctaEl.textContent;

    this.querySelectorAll('[data-plan-card]').forEach(c => c.removeAttribute('data-active'));
    card.setAttribute('data-active', '');

    const btn = this.querySelector('[data-cta-btn]');
    if (btn) {
      btn.classList.remove('plan-pulse');
      void btn.offsetWidth;
      btn.classList.add('plan-pulse');
    }
  }

  selectThumb(thumb) {
    const mainImg = this.querySelector('[data-main-image]');
    if (mainImg && thumb.dataset.fullSrc) mainImg.src = thumb.dataset.fullSrc;
    this.querySelectorAll('[data-thumb]').forEach(t => t.removeAttribute('data-active'));
    thumb.setAttribute('data-active', '');
  }
}

if (!customElements.get('membership-order')) customElements.define('membership-order', MembershipOrder);

  } catch(e) { console.error(e); }
})();
})();
